import { Component } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { NavNotification } from 'platfi-ui-components';

import toJS from 'HOC/toJS';

import {
  makeSelectPage,
  makeSelectLoading,
  makeSelectHasMore,
  makeSelectNotificationsList,
} from 'reducers/notifications/selectors';
import * as notificationActions from 'reducers/notifications/reducer';

const NavNotificationWrapped = toJS(NavNotification);

class ConnectedNavNotification extends Component {
  static propTypes = {
    notifications: PropTypes.oneOfType([PropTypes.instanceOf(Immutable.List), PropTypes.bool]),
    notificationsPagination: PropTypes.shape({
      page: PropTypes.number,
      loading: PropTypes.bool,
      hasMore: PropTypes.bool,
    }),
    requestNotifications: PropTypes.func.isRequired,
    requestMarkAsSeen: PropTypes.func.isRequired,
    requestMarkAsRead: PropTypes.func.isRequired,
    startNotificationPolling: PropTypes.func.isRequired,
    stopNotificationPolling: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.props.startNotificationPolling();
  }

  componentWillUnmount() {
    this.props.stopNotificationPolling();
  }

  onNotificationClicked = (notification) => {
    if (!notification) {
      return;
    }

    this.props.requestMarkAsRead(notification);
  };

  loadMore = () => {
    const {
      notificationsPagination: { page, loading, hasMore },
      requestNotifications,
    } = this.props;

    if (loading || !hasMore) {
      return;
    }

    requestNotifications(+page + 1);
  };

  renderNavNotification = () => {
    // do nothing
  };

  render() {
    const {
      notifications,
      requestMarkAsSeen,
      notificationsPagination: { hasMore, loading },
    } = this.props;

    return (
      <NavNotificationWrapped
        headerLabel="Notifications"
        hasMore={hasMore}
        loading={loading}
        notifications={notifications}
        onLoadMoreClicked={this.loadMore}
        onNotificationsSeen={requestMarkAsSeen}
        onNotificationClicked={this.onNotificationClicked}
      />
    );
  }
}

const mapStateToProps = createStructuredSelector({
  notifications: makeSelectNotificationsList(),
  notificationsPagination: createStructuredSelector({
    page: makeSelectPage(),
    loading: makeSelectLoading(),
    hasMore: makeSelectHasMore(),
  }),
});

export function mapDispatchToProps(dispatch) {
  return {
    requestMarkAsSeen: (ids) => dispatch(notificationActions.requestMarkAsSeen(ids)),
    requestMarkAsRead: (id) => dispatch(notificationActions.requestMarkAsRead(id)),
    requestNotifications: (page) => dispatch(notificationActions.requestNotifications(page)),
    startNotificationPolling: () => dispatch(notificationActions.startNotificationPolling()),
    stopNotificationPolling: () => dispatch(notificationActions.stopNotificationPolling()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ConnectedNavNotification);
